import { render, staticRenderFns } from "./BodyLoader.vue?vue&type=template&id=41f80664&"
import script from "./BodyLoader.vue?vue&type=script&lang=js&"
export * from "./BodyLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports